import * as React from "react";
import { useState, useRef } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { Button } from "@mui/material";
import _ from "lodash";
import ReactToPrint from "react-to-print";
import InvoicePrint from "./InvoicePrint";
import { getOrders } from "../../api/restApi";
import { useAppSelector } from "../../utils/hooks";
import { ordersData } from "../../store/reducer/ordersSlice";
import { customersData } from "../../store/reducer/customersSlice";
import Stack from "@mui/material/Stack";
import { generateBillForCustomer } from "../../utils/helpers";
import { ConvertOrderArrayToObject } from "../../utils/helpers";
import { useSelector } from "react-redux";
import OverlayLoader from "../../components/modals/OverlayLoader";

export default function AdminInvoice() {
  const [customer, setcustomer] = useState([]);
  const [orderByCustomer, setOrderByCustomer] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  console.log(selectedCustomer);
  const [selectedDate, setSelectedDate] = useState(null);

  const [productsInfo, setProductsInfo] = useState([]);
  const [value, setValue] = useState();
  const { customers } = useAppSelector(customersData);
  const formattedDate = new Date().toISOString().slice(0, 10);
  const { ordersDate } = useAppSelector(ordersData);
  const sortedOrdersDate = [...ordersDate].sort(
    (a, b) => new Date(b) - new Date(a)
  );
  const preparedBy = useSelector((state) => state.currentUser.name);
  const componentRef = useRef();

  const [open, setOpen] = useState(false);

  async function callData(date) {
    setOpen(true);
    try {
      setcustomer([]);
      setProductsInfo([]);
      let data = await getOrders(date);
      data = ConvertOrderArrayToObject(data);
      let orderType = [];
      let customers = _.sortBy(data.orders_customer, "customerId");
      console.log(customers);
      setcustomer(
        customers.map((pro) => {
          console.log(pro);
          return {
            ...pro,
            ...findCustomer(pro.customerId),
          };
        })
      );
      console.log(customer);

      if (orderType.length > 0) {
        setSelectedCustomer(orderType[0]);
      }
      setOpen(false);
    } catch {
      setOpen(false);
    }
  }

  const findCustomer = (id) => {
    let cust = customers.find((el) => el.id.toString() === id.toString());
    let today = new Date();
    let date =
      today.getDate() +
      "-" +
      (today.getMonth() + 1) +
      "-" +
      today.getFullYear();
    return {
      ...cust,
      label: cust.name_urdu,
      date: date,
      preparedBy: preparedBy,
    };
  };

  const handleSelectDate = async (event, newValue) => {
    console.log(newValue);
    setSelectedDate(newValue);
    callData(newValue);
  };

  const handleSelectCustomer = async (event, newValue) => {
    console.log(newValue);
    setSelectedCustomer(newValue);

    let cust = generateBillForCustomer(newValue);
    console.log(cust);
    setOrderByCustomer(cust);
  };

  return (
    <div>
      <ReactToPrint
        trigger={() => (
          <Button sx={{ margin: 1 }} variant="outlined">
            Print this out!
          </Button>
        )}
        content={() => componentRef.current}
      />
      <Stack
        style={{ marginTop: "3rem" }}
        alignItems="center"
        spacing={2}
        direction={"row"}
        justifyContent="center"
      >
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          options={sortedOrdersDate}
          sx={{
            minWidth: 300,
            display: "flex",
            justifyContent: "center",
          }}
          value={selectedDate}
          onChange={handleSelectDate}
          renderInput={(params) => (
            <TextField {...params} label="Select a date" />
          )}
        />

        {customer && customer.length > 0 && (
          <Autocomplete
            disablePortal
            id="combo-box-demo2"
            options={customer}
            sx={{
              minWidth: 300,
              display: "flex",
              justifyContent: "center",
            }}
            value={selectedCustomer}
            onChange={handleSelectCustomer}
            renderInput={(params) => (
              <TextField {...params} label="Select customer" />
            )}
          />
        )}
      </Stack>

      {orderByCustomer && <InvoicePrint invoice={orderByCustomer} />}

      <OverlayLoader open={open} />
    </div>
  );
}
